import * as React from "react";
import * as moment from "moment";
import { Input } from "@neworbit/simpleui-input";
import { union } from "lodash";
import { Form } from "semantic-ui-react";

interface Props {
    selectedDays: number[] | null;
    onChange: (selectedDays: number[] | null) => void;
}

export const DaySelector = ({ selectedDays, onChange }: Props) => {
    const onChangeCheckbox = React.useCallback((index: number) => (value: boolean) => {
        if (selectedDays === null) {
            return;
        }

        onChange(value ?
            union(selectedDays, [index]) :
            selectedDays.filter(d => d !== index));
    }, [selectedDays, onChange]);

    return (
        <Form.Field>
            <label>Working Week</label>
            <div className="day-selector">
                {moment.weekdaysShort(true).map((day, index) =>
                    (<Input.Checkbox
                        label={day}
                        key={index}
                        value={(selectedDays ?? []).indexOf(index) !== -1}
                        onChange={onChangeCheckbox(index)}
                    />)
                )}
            </div>
        </Form.Field>
    );
};
